import { Directive } from '@angular/core';
import {
   LcsChipMultiSelectTextContentFn,
   LcsChipMultiSelectTriggerComponent,
} from 'src/app/common-components/multi-select/chip-multi-select-trigger.component';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

@Directive({
    selector: 'lcs-chip-multi-select-trigger[ndtExtensionMultiSelect]',
    standalone: false
})
export class ExtensionChipMultiSelectTriggerDirective {
   constructor(trigger: LcsChipMultiSelectTriggerComponent<ExtensionOption>) {
      trigger.getDisplayText = entityChipMultiSelectText(trigger);
   }
}

export function entityChipMultiSelectText<T = ExtensionOption>(
   _multiSelect: LcsChipMultiSelectTriggerComponent<ExtensionOption>
): LcsChipMultiSelectTextContentFn<ExtensionOption> {
   return (item: ExtensionOption | null | undefined): string => {
      return `${item?.number} - ${item?.name}`;
   };
}
